<script>

import NewArticle from "@/views/components/cms/new/NewArticle.vue";

export default {
  name: "EinarbeitungNew",
  components: {
    NewArticle,
  },
}
</script>

<template>
  <NewArticle :category-id="7"></NewArticle>
</template>

<style scoped>

</style>
